import {
  ChevronDown,
  ChevronUp,
  Eye,
  Pen,
  Plus,
  Trash2,
  UserRoundPen,
} from "lucide-react";
import { useState, useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";
import { useStateValue } from "../../context/StateProvider";
import AgentDropdown from "./agentDropdown";
import {
  addTaskToDeal,
  getDealTasks,
  updateDealTasks,
} from "../../utils/firebasefunctions";
import TaskPopup from "./task-detail";
import StatusDropdown from "./StatusDropdown";

const Task = ({ deal, taskId }) => {
  console.log('deal',deal);

  const [tasks, setTasks] = useState([]);
  const [editingTaskId, setEditingTaskId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  const handleStatusChange = (taskId, newStatus) => {
    const updated = tasks.map((t) =>
      t.id === taskId ? { ...t, status: newStatus } : t,
    );

    handleUpdateTasks(updated);
  };

  function formatDate(date) {
    if (!date || date == "") return "";

    const [yyyy, mm, dd] = date?.split("-");
    return `${mm}/${dd}/${yyyy}`;
  }

  const handleUpdateTasks = async (updatedTasks) => {
    setTasks(updatedTasks);

    try {
      const cleanTasks = updatedTasks.map((t) => ({
        id: t.id,
        title: t.title || "",
        status: t.status || "Open",

        deadline: t.deadline ? String(t.deadline) : "",
        attachments: t.attachments || [],

        assignee:
          t.assignee && t.assignee.id
            ? {
                id: t.assignee.id,
                firstname: t.assignee.firstname,
                lastname: t.assignee.lastname,
                profilepicture: t.assignee.profilepicture || "",
                role: t.assignee.role,
              }
            : null,

        createdAt: t.createdAt ? new Date(t.createdAt).toISOString() : null,
      }));

      await updateDealTasks(String(deal.createdat), cleanTasks);
    } catch (err) {
      console.log("Update error", err);
    }
  };

  const handleSaveTask = (task) => {
    const trimmedTitle = task.title.trim();

    if (trimmedTitle === "") {
      // agar empty task hai to remove kar do
      const updated = tasks.filter((t) => t.id !== task.id);
      setTasks(updated);
      handleUpdateTasks(updated);
    } else {
      // save task
      const updated = tasks.map((t) =>
        t.id === task.id ? { ...t, title: trimmedTitle } : t,
      );
      setTasks(updated);
      handleUpdateTasks(updated);
    }

    setEditingTaskId(null);
  };

  useEffect(() => {
    const fetchTasks = async () => {
      if (!deal?.createdat) return;

      const data = await getDealTasks(String(deal.createdat));
      setTasks(data);
    };

    fetchTasks();
  }, [deal]);

  useEffect(() => {
    if (!taskId || tasks.length === 0 || showPopup) return;

    const foundTask = tasks.find((t) => String(t.id) === String(taskId));

    if (foundTask) {
      setSelectedTask(foundTask);
      setShowPopup(true);
    }
  }, [taskId, tasks]);

  const TaskCard = ({ task, editingTaskId, setEditingTaskId }) => {
    console.log("task", task);
    const [{ users }, dispatch] = useStateValue();

    const [editDeadline, setEditDeadline] = useState(false);
    const [showAssigneeDropdown, setShowAssigneeDropdown] = useState(false);
    const [showStatusDropdown, setShowStatusDropdown] = useState(false);

    const allAgent = users.filter(
      (u) =>
        (u.role === "Employee" ||
          u.role === "Admin" ||
          u.role === "Supervisor") &&
        u.type !== 1 &&
        u.type !== 2,
    );

    const getStatusColor = (status) => {
      if (status === "Open") return "bg-red-100 text-red-700";
      if (status === "In Progress") return "bg-blue-100 text-blue-700";
      if (status === "Completed") return "bg-green-100 text-green-700";
      return "bg-gray-100 text-gray-700";
    };

    const handleDeleteTask = () => {
      const updated = tasks.filter((t) => t.id !== task.id);

      handleUpdateTasks(updated);
    };

    const newmessagesuccess = async (title, id, message, taskid, type) => {
      try {

        const res = await fetch(
          "https://us-central1-team-edelstein.cloudfunctions.net/api/newmessage",

          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              title: title,
              message: message,
              id: id,
              taskid: taskid,
              dealid: deal?.createdat,
              type: type,
            }),
          },
        );
      
  
        if (res.status == 200) {
          console.log("new message sent " + JSON.stringify(res));
          const data = await res.json();

          console.log("Successfully Notified User");
        } else {
          
          console.log("Notififcation Error" + JSON.stringify(res));
        }
      } catch (error) {
        alert(error)
        console.error("Error:", error);
      }
    };

    return (
      <div className="border-t border-b border-gray-200 p-2 group">
        <div className="flex justify-between items-center gap-2 lg:gap-3">
          <div className="w-[40%] lg:w-[28%]">
            {editingTaskId === task.id ? (
              <input
                className="border px-2 py-1 rounded w-full text-sm"
                value={task.title}
                onChange={(e) => {
                  setTasks((prev) =>
                    prev.map((t) =>
                      t.id === task.id ? { ...t, title: e.target.value } : t,
                    ),
                  );
                }}
                onBlur={() => handleSaveTask(task)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); // newline prevent kare
                    handleSaveTask(task);
                  }
                }}
                autoFocus
              />
            ) : (
              <p
                className="cursor-pointer font-semibold line-clamp-1 text-sm text-gray-800 group-hover:text-blue-600 transition"
                onClick={() => {
                  setEditingTaskId(task.id);
                }}
              >
                {task.title || "Untitled Task"}
              </p>
            )}
          </div>

          <div className="w-[15%] lg:w-[10%] relative">
            <div
              className="flex items-center justify-center gap-2 cursor-pointer relative group"
              onClick={() => setShowAssigneeDropdown(!showAssigneeDropdown)}
            >
              {task.assignee?.profilepicture ? (
                <img
                  src={task.assignee.profilepicture}
                  className="w-6 h-6 rounded-full ring-2 ring-white shadow"
                  alt="assignee"
                />
              ) : (
                <FaUserCircle className="w-6 h-6 text-gray-400" />
              )}
              {task.assignee ? (
                <div className="absolute bottom-full mb-2 hidden group-hover:block bg-black text-white text-xs px-2 py-1 rounded whitespace-nowrap z-20">
                  {task.assignee
                    ? `${task.assignee.firstname || ""} ${task.assignee.lastname || ""}`
                    : "Unassigned"}
                </div>
              ) : (
                <div className="absolute bottom-full mb-2 hidden group-hover:block bg-black text-white text-xs px-2 py-1 rounded whitespace-nowrap z-20">
                  Unassigned
                </div>
              )}
            </div>

            {showAssigneeDropdown && (
              <AgentDropdown
                visible={showAssigneeDropdown}
                data={allAgent}
                style={{ top: "40px", left: "0" }}
                onSelect={(agent) => {
                  if (!agent) {
                    const updated = tasks.map((t) =>
                      t.id === task.id ? { ...t, assignee: null } : t,
                    );

                    handleUpdateTasks(updated);
                    setShowAssigneeDropdown(false);
                    return;
                  }

                  const minimalAgent = {
                    id: agent.id,
                    firstname: agent.firstname,
                    lastname: agent.lastname,
                    profilepicture: agent.profilepicture || "",
                    email: agent.email,
                    role: agent.role,
                  };
                  newmessagesuccess(
                    "New Task Assigned",
                    minimalAgent?.id || 0,
                    task?.title || "",
                    task?.id || "",
                    "newtask",
                  );

                  const updated = tasks.map((t) =>
                    t.id === task.id ? { ...t, assignee: minimalAgent } : t,
                  );

                  handleUpdateTasks(updated);
                  setShowAssigneeDropdown(false);
                }}
                onClose={() => setShowAssigneeDropdown(false)}
              />
            )}
          </div>

          <div className="w-[15%] lg:w-[19%] text-center hidden lg:block">
            {editDeadline ? (
              <input
                type="date"
                className="border px-2 py-1 rounded w-full text-sm"
                value={task.deadline}
                onChange={(e) => {
                  const value = e.target.value;

                  setTasks((prev) => {
                    const updated = prev.map((t) =>
                      t.id === task.id ? { ...t, deadline: value } : t,
                    );

                    let message = `deadline: ${formatDate(value)}`;
                    newmessagesuccess(
                      task?.title,
                      task?.assignee?.id || 0,
                      message || "",
                      task?.id || "",
                      "deadline",
                    );
                    handleUpdateTasks(updated);

                    return updated;
                  });
                }}
                onBlur={() => {
                  setEditDeadline(false);
                }}
                autoFocus
              />
            ) : (
              <p
                className={`cursor-pointer text-xs px-3 py-1 rounded-full inline-block ${
                  task.deadline
                    ? "bg-gray-100 text-gray-700"
                    : "bg-gray-50 text-gray-400"
                }`}
                onClick={() => setEditDeadline(true)}
              >
                {formatDate(task.deadline) || "No deadline"}
              </p>
            )}
          </div>
          <div 
          onClick={() => {
                setSelectedTask(task);
                setShowPopup(true);
              }}
          className="w-[15%] lg:w-[11%] justify-center hidden lg:flex hover:cursor-pointer">
            {task.attachments?.length > 0 ? (
              <p className="text-xs bg-gray-100 text-gray-700 w-fit px-2.5 py-0.5 rounded-full">
                {task.attachments?.length}
              </p>
            ) : (
              <p className="text-xs text-gray-400">N/A</p>
            )}
          </div>

          <div className="w-[30%] lg:w-[12%] relative">
            <div
              className={`w-full py-1.5 rounded-full text-center text-xs font-semibold cursor-pointer transition ${getStatusColor(
                task.status,
              )} hover:scale-105`}
              onClick={() => setShowStatusDropdown(!showStatusDropdown)}
            >
              {task.status}
            </div>

            {showStatusDropdown && (
              <StatusDropdown
                visible={showStatusDropdown}
                options={["Open", "In Progress", "Completed"]}
                style={{ top: "40px", left: "-50px" }}
                onSelect={(status) => {
                  handleStatusChange(task.id, status);
                  setShowStatusDropdown(false);
                }}
                onClose={() => setShowStatusDropdown(false)}
              />
            )}
          </div>
          <div className="w-[15%] lg:w-[8%] flex justify-end items-center gap-x-1 lg:gap-x-2 transition">
            <Pen
              size={18}
              className="text-gray-400 hover:text-[#1E293B] cursor-pointer hover:scale-110 transition"
              onClick={() => {
                setSelectedTask(task);
                setShowPopup(true);
              }}
            />
            <Trash2
              size={18}
              className="text-gray-400 hover:text-red-500 cursor-pointer hover:scale-110 transition"
              onClick={handleDeleteTask}
            />
          </div>
        </div>
      </div>
    );
  };

  const TaskAccordion = ({ status, title }) => {
    const [isOpen, setIsOpen] = useState(true);
    const filteredTasks = tasks.filter((t) => t.status === status);
    const addNewTask = async () => {
      const newTask = {
        id: Date.now(),
        title: "",
        assignee: null,
        deadline: "",
        status: status,
        image: null,
        createdAt: new Date(),
      };

      setTasks((prev) => [newTask, ...prev]);
      setEditingTaskId(newTask.id);

      try {
        await addTaskToDeal(String(deal.createdat), newTask);
      } catch (err) {
        console.log("Add error", err);
      }
    };

    return (
      <div className="bg-gray-50 rounded-xl mb-4">
        <div
          className="flex justify-between items-center p-2 cursor-pointer font-semibold text-gray-800 bg-white rounded-xl shadow-sm hover:shadow-md transition"
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="flex items-center gap-x-2">
            {isOpen ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
            <p>{title}</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs bg-gray-100 text-gray-700 px-2.5 py-0.5 rounded-full">
              {filteredTasks.length}
            </span>
            <Plus
              size={18}
              className="cursor-pointer text-white bg-[#1E293B] p-1 rounded-full hover:bg-green-600 transition"
              onClick={(e) => {
                e.stopPropagation();
                addNewTask();
              }}
            />
          </div>
        </div>
        {isOpen && (
          <div className="flex flex-col gap-3 py-3 lg:px-2">
            <div className="justify-between text-sm items-center flex">
              <div className="w-[40%] lg:w-[28%]">
                <p>Task Name</p>
              </div>
              <div className="w-[15%] lg:w-[10%] text-center">
                <p>Assign</p>
              </div>
              <div className="w-[15%] lg:w-[19%] text-center hidden lg:block">
                <p>Deadline</p>
              </div>
              <div className="w-[11%] text-center hidden lg:block">
                <p>Attachments</p>
              </div>
              <div className="w-[30%] lg:w-[12%] text-center pr-5">
                <p>Status</p>
              </div>
              <div className="w-[15%] lg:w-[8%] text-center">Action</div>
            </div>
            {filteredTasks.map((task) => (
              <TaskCard
                key={task.id}
                task={task}
                editingTaskId={editingTaskId}
                setEditingTaskId={setEditingTaskId}
              />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="p-2 lg:p-6 min-h-screen bg-gray-50">
        <TaskAccordion status="Open" title="Open" />
        <TaskAccordion status="In Progress" title="In Progress" />
        <TaskAccordion status="Completed" title="Completed" />
      </div>
      {showPopup && selectedTask && (
        <TaskPopup
          task={selectedTask}
          onClose={() => setShowPopup(false)}
          onUpdateTask={(updatedTask) => {
            const updated = tasks.map((t) =>
              t.id === updatedTask.id ? { ...t, ...updatedTask } : t,
            );
            handleUpdateTasks(updated);
            setSelectedTask(updatedTask);
          }}
        />
      )}
    </>
  );
};

export default Task;
